"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDestinationParentPageSlugQuery = getDestinationParentPageSlugQuery;
exports.getDestinationParentSlug = getDestinationParentSlug;
exports.getDestinationPostsQuery = getDestinationPostsQuery;
var _constants = require("./constants");
function getDestinationPostsQuery(destinationType) {
  return _constants.DESTINATION_POSTS_QUERY_MAP[destinationType];
}
function getDestinationParentPageSlugQuery(destinationType) {
  return _constants.DESTINATION_PARENT_PAGE_SLUG_QUERY_MAP[destinationType];
}
function getDestinationParentSlug(destinationType) {
  return _constants.DESTINATION_DEFAULT_POST_PARENT_SLUG_MAP[destinationType];
}